import { render, staticRenderFns } from "./PatientInputForm.vue?vue&type=template&id=1d57d249&scoped=true&"
import script from "./PatientInputForm.vue?vue&type=script&lang=js&"
export * from "./PatientInputForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientInputForm.vue?vue&type=style&index=0&id=1d57d249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57d249",
  null
  
)

export default component.exports